import { render, staticRenderFns } from "./KvSuggestorMultiple.vue?vue&type=template&id=f080e76e&"
import script from "./KvSuggestorMultiple.vue?vue&type=script&lang=js&"
export * from "./KvSuggestorMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports